import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"
import { ApiNames } from '../../components/Common/ApiManagement/apiServices'
import "./datatables.scss"
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { convertDecimalMinutesToDuration, scrollToView, showToaster } from "components/Common/common";
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
import { PAGEPATHS, SIDEBARDATA, USERTYPES } from "components/Common/Constant";
import { useSelector } from "react-redux";

const ScanList = (props) => {
  document.title = "Scan List";
  const navigate = useNavigate();

  useEffect(() => {
    props.setBreadcrumbItems("Scan List", [])
  })

  const user = useSelector((state) => state?.users.users)

   let eventSource;
  const [liveLogsData, setLiveLogsData] = useState('');
  let alreadyScrolledToLiveLogs = false;

  const handleClick = async (type, data) => {
    sessionStorage.setItem('Url', data.Url) // TODO: Use this value to fetch only certain scan data when the scanID may represent a bulk scan
    sessionStorage.setItem('domain', data.Domain)
    if (type === 1) {
      let userOrOrgId = user.userType === USERTYPES.Standard
        ? '&userId=' + user.userId
        : user.userType === USERTYPES.Organization
          ? '&orgId=' + user.orgId
          : ''
      await fetchData(`${ApiNames.LIST_SCANS}?scanId=${data._id}&url=${encodeURIComponent(data.Url)}${userOrOrgId}`, setScanDetailsData)
      scrollToView("specific-scan-details")

      setLiveLogsData(''); // Clear logs when viewing scan details
      if (eventSource) {
        eventSource.close(); // Close previous connection if it exists when viewing scan details
      }
    }
    if (type === 2) {
      sessionStorage.setItem('scanId', data._id)
      const { read } = user.permissions
      const formatSess = read.join(';').replace(/12;|14;/g, "")
      sessionStorage.setItem('pages', formatSess)

      const scanReport = SIDEBARDATA.filter(rep =>
        // rep.route !== PAGEPATHS.Addsiteurl &&
        rep.route !== PAGEPATHS.StartAScan &&
        rep.route !== PAGEPATHS.Accessmanage &&
        rep.route !== PAGEPATHS.Adduser &&
        rep.route !== PAGEPATHS.Usermanage &&
        rep.route !== PAGEPATHS.Scanlist &&
        rep.route !== PAGEPATHS.editOrganization &&
        rep.route !== PAGEPATHS.referrancrTable &&
        rep.route !== PAGEPATHS.ComplianceDashboard
      )
      const siteUrlSum = SIDEBARDATA.find(obj => obj.route === PAGEPATHS.Siteurlsummary)

      const pageKey = scanReport.find(obj =>
        (read.includes(siteUrlSum.pageCode) && obj.route === PAGEPATHS.Siteurlsummary) ||
        read.includes(obj.pageCode)
      )

      !pageKey || !pageKey.route
        ? showToaster(0, "Insufficient Permission: Contact admin.")
        : navigate(`${pageKey.route}/${data._id}`)
    }
    if(type===2){
      
        navigate (PAGEPATHS.Newdashboard);
    }
    if(type===3){
      sessionStorage.setItem('scanId', data._id)
       navigate(`${PAGEPATHS.ComplianceDashboard}/${data._id}`);
    }
        if(type===4){
      sessionStorage.setItem('scanId', data._id)
       navigate(`${PAGEPATHS.CustomerDashbord}/${data._id}`);
    }
   if (type === 5) {
      try {
        const res = await axiosInstance.post("/processor/run", {
          urlid: data.urlid,
          targetName: data.Domain
        },{ timeout: 60000 });
        if (res.data.status === 1) {
          console.log("Generated Report:", res.data.data);
          // const { frameworkId, targetId } = res.data.data;
          showToaster(1, "Report generated successfully!");
         const { frameworkId, targetId } = res.data.data; 
         navigate(`${PAGEPATHS.ComprehensiveComplianceDashboard}/${targetId}`);
          //  navigate(`${PAGEPATHS.FrameworkDetail}/${frameworkId}?target=${targetId}`);
          // 👉 You can show report in modal or redirect to a reports page
        } else {
          showToaster(0, res.data.message || "Failed to generate report");
        }
      } catch (err) {
        console.error(err);
        showToaster(0, "Error generating report");
      }
    }
    if(type===6){
          alreadyScrolledToLiveLogs = false;
          if (eventSource) {
            eventSource.close(); // Close previous connection if it exists
            setLiveLogsData(''); // Clear previous logs
          }
          eventSource = new EventSource(`${ApiNames.FETCH_LIVE_SCAN_LOGS}/${data._id}`)
          eventSource.onmessage = (event) => {
            setLiveLogsData((prevLogs) => {
              if (!alreadyScrolledToLiveLogs) scrollToView("live-scan-logs");
              alreadyScrolledToLiveLogs = true;
              return prevLogs + (prevLogs ? '\n' : '') + event.data; // Append new log data to the existing logs
            });
          };
          eventSource.addEventListener('start', (event) => {
            setLiveLogsData(''); // Clear previous logs on start (backup)
          });
          eventSource.addEventListener('restart', (event) => {
            setLiveLogsData(''); // Clear previous logs on restart
          });
          eventSource.addEventListener('errorEvent', (event) => {
            showToaster(0, event.data);
          });
          eventSource.onerror = (error) => { // Improve error handling
            // console.error('Error in EventSource:', error);
            eventSource.close(); // Close the connection on error
          }
    
          // Clear scan details rows when viewing live logs
          setScanDetailsData((prev) => ({
            ...prev,
            rows: []
          }));
        }
    }

  const getRedirectionRoute = (scan) => {
    const routeMap = {
      outbound: PAGEPATHS.Siteurlsummary,
      pagedata: PAGEPATHS.Siteurlsummary,
      third: PAGEPATHS.Siteurlsummary,
      a11y: PAGEPATHS.Accessibility,
      lighthouse: PAGEPATHS.Accessibility,
      analytics: PAGEPATHS.Analytics,
      dap: PAGEPATHS.Analytics,
      gov: PAGEPATHS.Analytics,
      pshtt: PAGEPATHS.Securitycomp,
      sslyze: PAGEPATHS.Securitycomp,
      csp: PAGEPATHS.Securitycomp,
      seo: PAGEPATHS.Searchengine,
      search: PAGEPATHS.Searchengine,
      trustymail: PAGEPATHS.Mailserver,
      uswds2: PAGEPATHS.Uswebdesignstd,
      wappybird: PAGEPATHS.Technologystack,
      zaproxy: PAGEPATHS.Vulnerability
    };
    return routeMap[scan] || null;
  }

  const redirectScanDetailsPage = (id, name) => {

    const route = getRedirectionRoute(name)

    if (!route) {
      showToaster(0, "Scan not available")
      return
    }

    const pageKey = SIDEBARDATA.find(obj => obj.route === route)

    if (!user.permissions.read.includes(pageKey?.pageCode)) {
      showToaster(0, "Insufficient Permission: Contact admin.")
      return
    }

    const oldScanId = sessionStorage.getItem('scanId')
    const existing = sessionStorage.getItem('pages')
    sessionStorage.setItem('scanId', id)

    if (pageKey && pageKey.pageCode) {
      if (oldScanId !== id) {
        sessionStorage.setItem('pages', pageKey.pageCode)
      } else if (existing && existing.split(';').includes(pageKey.pageCode.toString())) {
        console.log('No changes made in routes');
      } else if (existing) {
        sessionStorage.setItem('pages', `${existing};${pageKey.pageCode}`)
      } else {
        sessionStorage.setItem('pages', pageKey.pageCode)
      }
    }
    navigate(route)
  }

  const fetchData = async (url, setHook) => {
      const { data } = await axiosInstance.get(url)
  //   const data=[
  //     {
  //         "_id": "66d1f18f3727e92cd7a23c8a",
  //         "scanStartTime": "Aug-13-2024 13:07:02",
  //         "scanEndTime": "Aug-13-2024 13:08:29",
  //         "username": "user three",
  //         "scannedUrl": "https://www.acquisition.gov/",
  //         "Domain": "www.acquisition.gov",
  //         "oragnizationName": "Los Branch",
  //         "totalScanDuration": "87.24"
  //     },
  //     {
  //         "_id": "66d1f00e7a27bb07072b73ef",
  //         "scanStartTime": "Aug-13-2024 13:07:02",
  //         "scanEndTime": "Aug-13-2024 13:08:29",
  //         "username": "newuser",
  //         "scannedUrl": "https://www.acquisition.gov/",
  //         "Domain": "www.acquisition.gov",
  //         "oragnizationName": "Los Branch",
  //         "totalScanDuration": "87.24"
  //     },
  //     {
  //         "_id": "66d1f2a18da4796ad5d33547",
  //         "scanStartTime": "Aug-13-2024 13:07:02",
  //         "scanEndTime": "Aug-13-2024 13:08:29",
  //         "username": "testing",
  //         "scannedUrl": "https://www.acquisition.gov/",
  //         "Domain": "www.acquisition.gov",
  //         "oragnizationName": "Texas Branch",
  //         "totalScanDuration": "87.24"
  //     }
  // ]
     const validData = data.data.reduce((a, v) => {
    //  const validData = data.reduce((a, v) => {
      const { totalScanDuration, ...other } = v
      const formattedTsd = convertDecimalMinutesToDuration(totalScanDuration)
      const format = {
        ...other,
        totalScanDuration: formattedTsd,
        action: (
          <div className="">
            {url.includes('scanId') ? (
              <button
                className="waves-effect btn btn-link text-dark text-nowrap"
                variant="success"
                size="sm"
                onClick={() => redirectScanDetailsPage(v.ScanID, v.ScanName)}
              >
                Details
              </button>
            ) : (
              <>
                <button className="waves-effect btn btn-link text-dark text-nowrap" variant="success" size="sm" onClick={() => handleClick(1, v)}>Details</button>
                <span>|</span>
                <button className="waves-effect btn btn-link text-dark text-nowrap" variant="success" size="sm" onClick={() => handleClick(2, v)}>Dashboard</button>
                <span>|</span> 
                <button className="waves-effect btn btn-link text-dark text-nowrap" variant="success" size="sm" onClick={() => handleClick(3, v)}>Compliance Dashboard</button>
                <span>|</span> 
                <button className="waves-effect btn btn-link text-dark text-nowrap" variant="success" size="sm" onClick={() => handleClick(4, v)}>Custom Reports</button>
                <span>|</span>
                <button
                  className="waves-effect btn btn-link text-dark text-nowrap"
                  variant="success"
                  size="sm"
                  onClick={() => handleClick(5, v)}
                >
                  Generated Reports
                </button>
                 <span>|</span>
                  <button className="waves-effect btn btn-link text-dark text-nowrap" variant="success" size="sm" onClick={() => handleClick(6, v)}>Live Logs</button>
             </>
            )}
          </div>
        )
      }
      a.push(format)
      return a
    }, [])

    const adminCols = [
      {
        label: "Scan User",
        field: "username",
        sort: "asc",
        width: 270,
      },
      {
        label: "Scan User Organization",
        field: "organizationName",
        sort: "asc",
        width: 200,
      },
    ]

    setHook((prev) => {
      const adminAlreadyAdded = prev.columns.some(col => col.field === "_id"); // _id refers to ScanID, so why is this necessary? What is it used for?

      let updatedColumns;

      if (user.userType !== USERTYPES.Standard /*&& adminAlreadyAdded*/) {
        const validCol = user.userType === USERTYPES.Organization
          ? [adminCols.shift()]
          : adminCols

        const filteredColumns = prev.columns.filter(col =>
          !validCol.some(adminCol => adminCol.field === col.field)
        );

        filteredColumns.splice(3, 0, ...validCol);
        updatedColumns = filteredColumns;
      } else {
        updatedColumns = prev.columns;
      }

      updatedColumns = updatedColumns.reduce((unique, col) => {
        if (!unique.some(u => u.field === col.field)) {
          unique.push(col);
        }
        return unique;
      }, []);

      return {
        ...prev,
        columns: updatedColumns,
        rows: validData
      };
    });
  }


  useEffect(() => {
    const getScanList = async () => {
      console.log(user,"useruseruser");
      
      try {
        const concat = user.userType === USERTYPES.Standard
          ? `?userId=${user.userId}`
          : user.userType === USERTYPES.Organization
            ? `?orgId=${user.orgId}`
            : ''


        await fetchData(ApiNames.LIST_SCANS + concat, setScanData)
      } catch (e) {
        console.error(e);
      }
    }
    if (user)
      getScanList()
  }, [user])

  const [scanDetailsData, setScanDetailsData] = useState({
    columns: [
      {
        label: "URL",
        field: "URL",
        sort: "asc",
        width: 100,
      },
      {
        label: "Scan Version",
        field: "VersionId",
        sort: "asc",
        width: 50
      },
      {
        label: "Scan Name",
        field: "ScanName",
        sort: "asc",
        width: 150,
      },
      {
        label: "Scan Start Time",
        field: "scanStartTime",
        sort: "asc",
        width: 100,
      },
      {
        label: "Scan End Time",
        field: "scanEndTime",
        sort: "asc",
        width: 100,
      },
      {
        label: "Total Scan Time",
        field: "totalScanDuration",
        sort: "asc",
        width: 100,
      },
      {
        label: "Link to View Scan",
        field: "action",
        sort: "asc",
        width: 150,
      }
    ],
    rows: []
  })

  const [scanData, setScanData] = useState({
    columns: [
      {
        label: "URL",
        field: "Url",
        sort: "asc",
        width: 100,
      },
      {
        label: "Scan Id",
        field: "_id",
        sort: "asc",
        width: 150,
      },
      {
        label: "Scan Status",
        field: "scanStatus",
        sort: "asc",
        width: 50,
      },
      {
        label: "Scan Start Time",
        field: "scanStartTime",
        sort: "asc",
        width: 100,
      },
      {
        label: "Scan End Time",
        field: "scanEndTime",
        sort: "asc",
        width: 100,
      },
      {
        label: "Total Scan Time",
        field: "totalScanDuration",
        sort: "asc",
        width: 100,
      },
      {
        label: "Link to View Scan",
        field: "action",
        sort: "asc",
        width: 150,
      }
    ],
    rows: []
  })

  return (
    <React.Fragment>
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <MDBDataTable responsive striped data={scanData} />
            </CardBody>
          </Card>
          {scanDetailsData.rows.length !== 0 && (
            <CardBody id="specific-scan-details">
              <Card style={{ padding: '1.5em' }}>
                <CardTitle className="h1 spec-scan-detail">
                  Scan Details - <span style={{ color: '#e67552' }}>{sessionStorage.getItem('Url') || ''}</span>
                </CardTitle>
                <MDBDataTable responsive striped data={scanDetailsData} />
              </Card>
            </CardBody>
          )}
           {liveLogsData.length !== 0 && (
            <CardBody id="live-scan-logs">
              <Card style={{ padding: '1.5em' }}>
                <CardTitle className="h1 live-scan-log">
                  Live Scan Logs - <span style={{ color: '#e67552' }}>{sessionStorage.getItem('Url') || ''}</span>
                </CardTitle>
                <div style={{ height: '25em' }} className="overflow-auto">
                  <pre>{liveLogsData}</pre>
                </div>
              </Card>
            </CardBody>
          )}
        </Col>
      </Row>

    </React.Fragment >
  )
}
export default connect(null, { setBreadcrumbItems })(ScanList)